exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3ZEXrzxdBGuy3J3_WLWgS_{height:16px;position:relative}._3ZEXrzxdBGuy3J3_WLWgS_ div{display:inline-block}.jC6q-YZNA221jtS41fB6W>div{height:24px;width:24px}.S7r3QdWwLFBm6rDWZ5swv{font-size:10px;color:\"[theme:neutralSecondaryAlt, default:#767676]\";position:absolute;top:0}html[dir=ltr] .S7r3QdWwLFBm6rDWZ5swv{padding-left:4px}html[dir=rtl] .S7r3QdWwLFBm6rDWZ5swv{padding-right:4px}", ""]);
// Exports
exports.locals = {
	"indicatorContainer": "_3ZEXrzxdBGuy3J3_WLWgS_",
	"personaCoinFix": "jC6q-YZNA221jtS41fB6W",
	"isTypingText": "S7r3QdWwLFBm6rDWZ5swv"
};